import { createContext } from 'react';
var SWRConfigContext = createContext({});
SWRConfigContext.displayName = 'SWRConfigContext';
export default SWRConfigContext;
